import React from "react";
import { Text, Card, SkeletonLoader } from "@merge-api/merge-javascript-shared";
import useAppContext from "../../context/useAppContext";
import { formatSyncFrequncyPlans } from "../settings/billing/BillingUtils";

const DashboardSyncFrequency = () => {
  const { user } = useAppContext();
  const syncPlanMap = user.organization.sync_frequency_plans || {};
  const defaultSyncPlan = syncPlanMap["DEFAULT"];

  return (
    <Card className="p-4 flex flex-row justify-between items-center">
      <Text variant="h5">Sync frequency</Text>
      <Text variant="h5" className="text-yellow-60">
        {defaultSyncPlan ? (
          formatSyncFrequncyPlans(defaultSyncPlan)
        ) : (
          <SkeletonLoader height={14} width={40} borderRadius={4} />
        )}
      </Text>
    </Card>
  );
};

export default DashboardSyncFrequency;
